<div class="container">
    <div class="section-heading text-center mb-2">
        <h2 class="m-0">Featured Projects</h2>
    </div>
    <div class="row gx-0">
        <div class="project-box gy-5" style="background-image: url(assets/img/project-1.jpg);">
            <div class="row align-items-end gy-5">
                <div class="col-lg-7">
                    <div class="project-desc">
                        <h3>Project 1</h3>
                        <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate</p>
                        <div class="btn-bar">
                            <a class="px-btn light px_modal" data-bs-toggle="modal" 
                            data-bs-target="#project_1"><span>View Project</span> <i class="bi-arrow-right"></i> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 text-lg-end">
                    <div class="project-tags">
                        <span>Web Design</span>
                        <span>Web Design</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="project-box gy-5" style="background-image: url(assets/img/project-2.jpg);">
            <div class="row align-items-end gy-5">
                <div class="col-lg-7">
                    <div class="project-desc">
                        <h3>Project 2</h3>
                        <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate</p>
                        <div class="btn-bar">
                            <a class="px-btn light px_modal" data-bs-toggle="modal" 
                            data-bs-target="#project_2"><span>View Project</span> <i class="bi-arrow-right"></i> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 text-lg-end">
                    <div class="project-tags">
                        <span>Web Design</span>
                        <span>Web Design</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="project-box gy-5" style="background-image: url(assets/img/project-3.jpg);">
            <div class="row align-items-end gy-5">
                <div class="col-lg-7">
                    <div class="project-desc">
                        <h3>Project 3</h3>
                        <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate</p>
                        <div class="btn-bar">
                            <a class="px-btn light px_modal" data-bs-toggle="modal" 
                            data-bs-target="#project_3"><span>View Project</span> <i class="bi-arrow-right"></i> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 text-lg-end">
                    <div class="project-tags">
                        <span>Web Design</span>
                        <span>Web Design</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

